import type {CopilotWorkStartedEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@primer/react'
import {safeHttpUrl} from '../../../../helpers/unified-batch-url-safety'
import {TimelineAuthor} from '../TimelineAuthor'
import {getCopilotWorkAutomation} from '../copilot-work-automation'

type WorkInfo = Pick<CopilotWorkStartedEventInfo, 'sessionUrl' | 'onBehalfOf' | 'automationName' | 'automationUrl'>

export function CopilotWorkEventText({info, actionText}: {info: WorkInfo; actionText: string}) {
  const sessionUrl = safeHttpUrl(info.sessionUrl?.trim())
  const automation = getCopilotWorkAutomation(info)
  const onBehalfOf = info.onBehalfOf

  return (
    <>
      {sessionUrl ? (
        <Link inline href={sessionUrl} className="fgColor-default text-semibold">
          {actionText}
        </Link>
      ) : (
        <span>{actionText}</span>
      )}
      {!automation && onBehalfOf?.displayLogin.trim() ? (
        <>
          {' on behalf of '}
          <TimelineAuthor
            avatarUrl={onBehalfOf.avatarUrl}
            login={onBehalfOf.displayLogin}
            slug={onBehalfOf.slug}
            userType={onBehalfOf.userType}
          />
        </>
      ) : null}
    </>
  )
}
